import "./FormDivider.scss"

const FormDivider = () => <div className="ui-form-divider"></div>

export default FormDivider